import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { FormListBase, FormListBaseGrid, FormListBaseTab, FormListBaseToolbar } from '../base';
import useCustomDataSource, { IFormBaseDataSourceOptions, Mode } from "../../hooks/useCustomDataSource";
import IEnregistrement from '../../models/IEnregistrement';
import IGestionEnregistrement from '../../models/IGestionEnregistrement';
import useClient from '../../components/selectbox/client';
import FormSysteme from '../../components/forms/form-systeme';
import { Item as TabItem } from "devextreme-react/tab-panel";
import Form, { GroupItem, SimpleItem, Label } from "devextreme-react/form";
import { Button, SelectBox, TextBox } from 'devextreme-react';
import useApi from '../../hooks/useApi';
import IClient from '../../models/IClient';
import { addDays, format } from 'date-fns';
import useLookUpBase from '../../components/selectbox/LookupBase';
import { Capture, CaptureDetails, EnregistrementDetails, IActiviteEnregistrement, IDataCapture, IDataForfaitsFacture, IFacturationDetails, IEnregistrementDetails, IHistoriqueAccompagnateur, IPointEauEnregistrement, ISecteurEnregistrement } from './type';
import DataGrid, { Column, Editing, DataGridTypes, Grouping, GroupPanel, Lookup } from "devextreme-react/data-grid";
import CapturesDetailsGrid from './captures-details-grid';
import CapturesEmplacementsGrid from './captures-emplacements-grid';
import createLookup from './use-lookups-enregistrements';
import { alertEnregistrement, appliquerCapturesAEnregistrement, assurerEmplacementAvecAuMoinsUnDetail, buildDatesParticipation, calculerPrisesEmplacement, compterDetailsCaptureActifs, creerDetailCaptureVide, creerEmplacementVide, filtrerCapturesActivesPourDetail, filtrerCapturesPourDetail, filtrerParticipantsDatesParticipation, fusionnerEmplacement, getActiviteRowData, IParticipantIdentity, isDateExcludedInParticipation, isParticipationDateInRange, mettreAJourDetailsCapture, reorganizeData, removeAccompagnateurDesDetailsEnregistrement, setAllParticipantExclusions, shouldHideExcludedParticipationDates, synchroniserDetailsCapture, syncDatesParticipationForEnregistrement, toggleParticipantExclusion, useFetchData, validerEmplacementsOntAuMoinsUnDetail } from './utilitaires';
import Guid from '../../models/Guid';
import IEnregistrementAccompagnateur from '../../models/IEnregistrementAccompagnateur';
import IBaseModel from '../../models/IBaseModel';
import './gestion-enregistrement.css';
import PopupPage, { useContextPopupPage } from '../../components/popups/PopupPage';
import PopupHistoriqueAccompagnateurs from './popup-historique-accompagnateurs';
import GestionFacturation from '../gestion-facturation/gestion-facturation';


interface IGestionEnregistrementProps {
  isModeSelection?: boolean,
}

export default function GestionEnregistrement({ isModeSelection }: IGestionEnregistrementProps) {
  const formRef = useRef<any>(null);

  const enregistrementFormDataSourceOptions: IFormBaseDataSourceOptions<IGestionEnregistrement> = useMemo(() => ({
    path: "EnregistrementEntete",
    primaryKey: "idEnregistrementEntete",
    customReadByIdPath: "EnregistrementEntete/{key}/gestion",
    customSauvegarderPath: "EnregistrementEntete/save",
  }), []);

  const enregistrementFormDataSource = useCustomDataSource<IEnregistrement, IGestionEnregistrement>(enregistrementFormDataSourceOptions);
  const { selectedDataRow: selectedEnregistrement, onFieldDataChanged, isFieldModifier, setMode, mode, setIsFieldModifier, setSelectedDataRow, sauvegarder } = enregistrementFormDataSource;
  const { clientEditorOptions, client, PopupGestionClient } = useClient(true);
  const [dataSourceSelectActivite, setDataSourceSelectActivite] = useState<IActiviteEnregistrement[]>();
  const [dataSourceSelectSecteur, setDataSourceSelectSecteur] = useState<ISecteurEnregistrement[]>();
  const [dataSourceSelectpointEau, setDataSourceSelectpointEau] = useState<IPointEauEnregistrement[]>();
  const [dataSourceForfaitsFactures, setDataForfaitsFactures] = useState<IDataForfaitsFacture>();
  const [dataSourceFacturationDetails, setDataSourceFacturationDetails] = useState<IFacturationDetails[]>([]);
  const [idActiviteSelected, setIdActiviteSelected] = useState<Guid>(Guid.empty)
  const [dataSourceCapture, setDataSourceCapture] = useState<IDataCapture>();
  const [idEnregistrementDetailCaptureSelectionne, setIdEnregistrementDetailCaptureSelectionne] = useState<string>();
  const [idCaptureSelectionne, setIdCaptureSelectionne] = useState<string>();
  const [idCaptureDetailSelectionne, setIdCaptureDetailSelectionne] = useState<string>();
  const [capturesModifiees, setCapturesModifiees] = useState(false);
  const [selectedActivite, setSelectedActivite] = useState<Guid>();
  const [selectedSecteur, setSelectedSecteur] = useState<Guid>();
  const [selectedPointEau, setSelectedPointEau] = useState<Guid>();
  const [nomClient, setNomClient] = useState<string>('');
  const [clientNames, setClientNames] = useState({ nom: '', prenom: '' });
  const [isHistoriqueAccompagnateursOpen, setIsHistoriqueAccompagnateursOpen] = useState(false);
  const [isPopupFacturationOpen, setIsPopupFacturationOpen] = useState(false);
  const [idFacturationEntetePopup, setIdFacturationEntetePopup] = useState<Guid>();
  const { setSelectedValue } = useContextPopupPage();

  const { editorOptions: plaquesEditorOption } = useLookUpBase({ isModeModifier: mode !== Mode.Lecture, controllerName: "clientPlaque", showClear: mode !== Mode.Lecture, showDropDown: false, showFind: false });
  const { editorOptions: lieuSejourEditorOption } = useLookUpBase({ isModeModifier: mode !== Mode.Lecture, controllerName: "LieuSejour", showClear: mode !== Mode.Lecture });
  const { editorOptions: typeSejourEditorOption } = useLookUpBase({ isModeModifier: mode !== Mode.Lecture, controllerName: "TypeSejours", showClear: mode !== Mode.Lecture });
  const { editorOptions: activiteEditorOption } = useLookUpBase({ isModeModifier: mode !== Mode.Lecture, controllerName: "Activite", showClear: mode !== Mode.Lecture });
  const { editorOptions: secteurEditorOption } = useLookUpBase({ isModeModifier: mode !== Mode.Lecture, controllerName: "secteur", showClear: mode !== Mode.Lecture });

  // TODO BUG as popup
  const { editorOptions: pointEauEditorOption } = useLookUpBase({ isModeModifier: mode !== Mode.Lecture, controllerName: "pointeau", showClear: mode !== Mode.Lecture });

  const { editorOptions: secteurEditorOptions } = useLookUpBase({ isModeModifier: mode !== Mode.Lecture, controllerName: "secteur", showClear: mode !== Mode.Lecture });
  const { fetchAndSetData } = useFetchData();
  const { fetchData } = useApi();
  const enregistrementDetailsFilterValue = useMemo(() => ["isDeleted", "anyof", [null, false]], []);
  const accompagnateursFilterValue = useMemo(() => ["isDeleted", "anyof", [null, false]], []);
  const {
    getData: getCapture,
    getData: getForfaitsFactures,
    getData: getFacturationDetails
  } = useApi('EnregistrementEntete');
  const { getData: getActivites } = useApi('Activite');
  const { getData: getclient } = useApi<IClient>("client");

  const dateEditorOptions = useMemo(() => {
    return {
      displayFormat: 'dd-MM-yyyy HH:mm',
    };
  }, []);

  const onSelectionchanged = (item: any, e: string) => {
    setIsFieldModifier(true);
    setSelectedDataRow((prev: IGestionEnregistrement) => {
      return { ...prev, [e]: item.id }
    })
  }

  const [chasse, setcChasse] = useState<boolean>(false)

  const enregistrementDetailsCapture = useMemo(
    () => synchroniserDetailsCapture(
      selectedEnregistrement?.enregistrementDetails,
      dataSourceCapture?.enregistrementDetailsCapture,
      dataSourceSelectActivite,
    ),
    [selectedEnregistrement?.enregistrementDetails, dataSourceCapture?.enregistrementDetailsCapture, dataSourceSelectActivite],
  );

  useEffect(() => {
    if (enregistrementDetailsCapture[0]?.chasse !== undefined) setcChasse(enregistrementDetailsCapture[0]?.chasse)
  }, [enregistrementDetailsCapture])

  const detailCaptureSelectionne = useMemo(
    () => enregistrementDetailsCapture.find(
      (detail) => String(detail.idEnregistrementDetail) === String(idEnregistrementDetailCaptureSelectionne),
    ),
    [enregistrementDetailsCapture, idEnregistrementDetailCaptureSelectionne],
  );

  const emplacementsSelectionnes = useMemo(
    () => (detailCaptureSelectionne
      ? filtrerCapturesActivesPourDetail(
        detailCaptureSelectionne.captures,
        detailCaptureSelectionne.idEnregistrementDetail,
      )
      : []),
    [detailCaptureSelectionne],
  );

  const detailsCaptureSelectionnes = useMemo(() => {
    const emplacement = emplacementsSelectionnes.find(
      (capture) => String(capture.idCapture) === String(idCaptureSelectionne),
    );
    return (emplacement?.capturesDetails ?? []).filter((detail) => !detail.isDeleted);
  }, [emplacementsSelectionnes, idCaptureSelectionne]);

  const modifierDetailsCapture = useCallback((
    updater: (details: EnregistrementDetails[]) => EnregistrementDetails[],
  ) => {
    setDataSourceCapture((prev) => {
      if (!prev) {
        return prev;
      }

      const detailsSynchronises = synchroniserDetailsCapture(
        selectedEnregistrement?.enregistrementDetails,
        prev.enregistrementDetailsCapture ?? [],
        dataSourceSelectActivite,
      );

      const detailsMisesAJour = updater(detailsSynchronises);

      return {
        ...prev,
        enregistrementDetailsCapture: synchroniserDetailsCapture(
          selectedEnregistrement?.enregistrementDetails,
          detailsMisesAJour,
          dataSourceSelectActivite,
        ),
      };
    });
    setIsFieldModifier(true);
    setCapturesModifiees(true);
  }, [dataSourceSelectActivite, selectedEnregistrement?.enregistrementDetails, setIsFieldModifier]);

  useEffect(() => {
    setIdEnregistrementDetailCaptureSelectionne(undefined);
    setIdCaptureSelectionne(undefined);
    setIdCaptureDetailSelectionne(undefined);
    setCapturesModifiees(false);
  }, [selectedEnregistrement.idEnregistrementEntete]);

  useEffect(() => {
    if (!enregistrementDetailsCapture.length) {
      setIdEnregistrementDetailCaptureSelectionne(undefined);
      setIdCaptureSelectionne(undefined);
      return;
    }

    const selectionValide = enregistrementDetailsCapture.some(
      (detail) => String(detail.idEnregistrementDetail) === String(idEnregistrementDetailCaptureSelectionne),
    );

    if (!selectionValide) {
      setIdEnregistrementDetailCaptureSelectionne(String(enregistrementDetailsCapture[0].idEnregistrementDetail));
    }
  }, [enregistrementDetailsCapture, idEnregistrementDetailCaptureSelectionne]);

  useEffect(() => {
    if (!emplacementsSelectionnes.length) {
      setIdCaptureSelectionne(undefined);
      return;
    }

    const selectionValide = emplacementsSelectionnes.some(
      (capture) => String(capture.idCapture) === String(idCaptureSelectionne),
    );

    if (!selectionValide) {
      setIdCaptureSelectionne(String(emplacementsSelectionnes[0].idCapture));
    }
  }, [emplacementsSelectionnes, idCaptureSelectionne]);

  useEffect(() => {
    if (!detailsCaptureSelectionnes.length) {
      setIdCaptureDetailSelectionne(undefined);
      return;
    }

    const selectionValide = detailsCaptureSelectionnes.some(
      (detail) => String(detail.idCaptureDetail) === String(idCaptureDetailSelectionne),
    );

    if (!selectionValide) {
      setIdCaptureDetailSelectionne(String(detailsCaptureSelectionnes[0].idCaptureDetail));
    }
  }, [detailsCaptureSelectionnes, idCaptureDetailSelectionne]);

  const handleActiviteCaptureFocusedRowChanged = useCallback((e: DataGridTypes.FocusedRowChangedEvent) => {
    const idDetail = e.row?.data?.idEnregistrementDetail;
    setIdEnregistrementDetailCaptureSelectionne(idDetail ? String(idDetail) : undefined);
    setIdCaptureSelectionne(undefined);
    setIdCaptureDetailSelectionne(undefined);
  }, []);

  const handleAjouterEmplacement = useCallback(() => {
    if (
      !detailCaptureSelectionne
      || (!detailCaptureSelectionne.peche && !detailCaptureSelectionne.chasse)
      || !selectedEnregistrement.idEnregistrementEntete
    ) {
      return;
    }

    const nouvelEmplacement = assurerEmplacementAvecAuMoinsUnDetail(creerEmplacementVide(
      detailCaptureSelectionne.idEnregistrementDetail,
      selectedEnregistrement.idEnregistrementEntete,
      detailCaptureSelectionne.chasse,
      detailCaptureSelectionne.idPointEau,
      detailCaptureSelectionne.idSecteur,
    ));

    modifierDetailsCapture((details) => mettreAJourDetailsCapture(
      details,
      detailCaptureSelectionne.idEnregistrementDetail,
      (detail) => ({
        ...detail,
        captures: [
          nouvelEmplacement,
          ...filtrerCapturesActivesPourDetail(detail.captures, detailCaptureSelectionne.idEnregistrementDetail),
        ],
      }),
      detailCaptureSelectionne,
    ));

    setIdCaptureSelectionne(nouvelEmplacement.idCapture);
    const premierDetail = nouvelEmplacement.capturesDetails?.find((detail) => !detail.isDeleted);
    setIdCaptureDetailSelectionne(premierDetail ? String(premierDetail.idCaptureDetail) : undefined);
  }, [detailCaptureSelectionne, modifierDetailsCapture, selectedEnregistrement.idEnregistrementEntete]);

  const handleSupprimerEmplacement = useCallback(() => {
    if (!detailCaptureSelectionne || !idCaptureSelectionne) {
      return;
    }

    modifierDetailsCapture((details) => mettreAJourDetailsCapture(
      details,
      detailCaptureSelectionne.idEnregistrementDetail,
      (detail) => ({
        ...detail,
        captures: filtrerCapturesPourDetail(detail.captures, detail.idEnregistrementDetail).map((capture) =>
          String(capture.idCapture) === String(idCaptureSelectionne)
            ? { ...capture, isDeleted: true }
            : capture,
        ),
      }),
      detailCaptureSelectionne,
    ));
    setIdCaptureSelectionne(undefined);
  }, [detailCaptureSelectionne, idCaptureSelectionne, modifierDetailsCapture]);

  const handleEmplacementUpdated = useCallback((emplacement: Capture) => {
    if (!detailCaptureSelectionne) {
      return;
    }

    modifierDetailsCapture((details) => mettreAJourDetailsCapture(
      details,
      detailCaptureSelectionne.idEnregistrementDetail,
      (detail) => ({
        ...detail,
        captures: filtrerCapturesPourDetail(detail.captures, detail.idEnregistrementDetail).map((capture) =>
          String(capture.idCapture) === String(emplacement.idCapture)
            ? fusionnerEmplacement(capture, emplacement)
            : capture,
        ),
      }),
      detailCaptureSelectionne,
    ));
  }, [detailCaptureSelectionne, modifierDetailsCapture]);

  const handleAjouterDetailCapture = useCallback(() => {
    if (!detailCaptureSelectionne || !idCaptureSelectionne) {
      return;
    }

    const nouveauDetail = creerDetailCaptureVide(idCaptureSelectionne);

    modifierDetailsCapture((details) => mettreAJourDetailsCapture(
      details,
      detailCaptureSelectionne.idEnregistrementDetail,
      (detail) => ({
        ...detail,
        captures: filtrerCapturesPourDetail(detail.captures, detail.idEnregistrementDetail).map((capture) => {
          if (String(capture.idCapture) !== String(idCaptureSelectionne)) {
            return capture;
          }

          const capturesDetails = [nouveauDetail, ...(capture.capturesDetails ?? [])];
          return {
            ...capture,
            capturesDetails,
            prises: calculerPrisesEmplacement({ ...capture, capturesDetails }),
          };
        }),
      }),
      detailCaptureSelectionne,
    ));
    setIdCaptureDetailSelectionne(nouveauDetail.idCaptureDetail);
  }, [detailCaptureSelectionne, idCaptureSelectionne, modifierDetailsCapture]);

  const handleSupprimerDetailCapture = useCallback(() => {
    if (!detailCaptureSelectionne || !idCaptureSelectionne || !idCaptureDetailSelectionne) {
      return;
    }

    const emplacement = emplacementsSelectionnes.find(
      (capture) => String(capture.idCapture) === String(idCaptureSelectionne),
    );
    if (compterDetailsCaptureActifs(emplacement) <= 1) {
      alertEnregistrement('Erreur', 'Impossible de supprimer le dernier détail d\'un emplacement.');
      return;
    }

    modifierDetailsCapture((details) => mettreAJourDetailsCapture(
      details,
      detailCaptureSelectionne.idEnregistrementDetail,
      (detail) => ({
        ...detail,
        captures: filtrerCapturesPourDetail(detail.captures, detail.idEnregistrementDetail).map((capture) => {
          if (String(capture.idCapture) !== String(idCaptureSelectionne)) {
            return capture;
          }

          const capturesDetails = (capture.capturesDetails ?? []).map((captureDetail) =>
            String(captureDetail.idCaptureDetail) === String(idCaptureDetailSelectionne)
              ? { ...captureDetail, isDeleted: true }
              : captureDetail,
          );

          return {
            ...capture,
            capturesDetails,
            prises: calculerPrisesEmplacement({ ...capture, capturesDetails }),
          };
        }),
      }),
      detailCaptureSelectionne,
    ));
    setIdCaptureDetailSelectionne(undefined);
  }, [detailCaptureSelectionne, emplacementsSelectionnes, idCaptureDetailSelectionne, idCaptureSelectionne, modifierDetailsCapture]);

  const handleDetailCaptureUpdated = useCallback((captureDetail: CaptureDetails) => {
    if (!detailCaptureSelectionne || !idCaptureSelectionne) {
      return;
    }

    modifierDetailsCapture((details) => mettreAJourDetailsCapture(
      details,
      detailCaptureSelectionne.idEnregistrementDetail,
      (detail) => ({
        ...detail,
        captures: filtrerCapturesPourDetail(detail.captures, detail.idEnregistrementDetail).map((capture) => {
          if (String(capture.idCapture) !== String(idCaptureSelectionne)) {
            return capture;
          }

          const capturesDetails = (capture.capturesDetails ?? []).map((detailItem) =>
            String(detailItem.idCaptureDetail) === String(captureDetail.idCaptureDetail)
              ? captureDetail
              : detailItem,
          );

          return {
            ...capture,
            capturesDetails,
            prises: calculerPrisesEmplacement({ ...capture, capturesDetails }),
          };
        }),
      }),
      detailCaptureSelectionne,
    ));
  }, [detailCaptureSelectionne, idCaptureSelectionne, modifierDetailsCapture]);

  useEffect(() => {
    try {
      if (selectedEnregistrement.idEnregistrementEntete) {
        getclient({ customPath: `client/${selectedEnregistrement.idClient}` })
          .then(client => {
            if (client) {
              setClientNames({ nom: client.nom ?? '', prenom: client.prenom ?? '' });
              setNomClient(`${client.nom} ${client.prenom}`)
            }
          })
          .catch((error) => {
            console.log(error)
          })

        getForfaitsFactures({ customPath: `Enregistrement/${selectedEnregistrement.idClient}/ForfaitsFactures` })
          .then((result) => {
            setDataForfaitsFactures(result as IDataForfaitsFacture)
          })
          .catch((error) => {
            console.log()
          })

        getCapture({ customPath: `Enregistrement/${selectedEnregistrement.idEnregistrementEntete}/Captures` })
          .then((result) => {
            setDataSourceCapture(result as IDataCapture)
          })
          .catch((error) => {
            console.log()
          })
        getActivites({ customPath: `Activite/lookupActiviteEnregistrement` })
          .then((result) => {
            setDataSourceSelectActivite(result as IActiviteEnregistrement[])
          })
          .catch((error) => {
            console.log()
          })
        getFacturationDetails({ customPath: `Enregistrement/${selectedEnregistrement.idEnregistrementEntete}/FacturationDetails` })
          .then((result) => {
            setDataSourceFacturationDetails(result as IFacturationDetails[])
          })
          .catch((error) => {

          })
      }
    } catch (error) {

    }
  }, [selectedEnregistrement])

  const notesOptions = useMemo(() => {
    return { height: 100 };
  }, []);

  const getClientNames = useCallback(() => {
    if (clientNames.nom || clientNames.prenom) {
      return clientNames;
    }
    const selectedClient = client?.find((entry) => entry.idClient?.equals(selectedEnregistrement.idClient));
    if (selectedClient?.nom) {
      return { nom: selectedClient.nom, prenom: selectedClient.prenom ?? '' };
    }
    const parts = nomClient.trim().split(/\s+/);
    if (parts.length >= 2) {
      return { nom: parts[0], prenom: parts.slice(1).join(' ') };
    }
    return { nom: nomClient, prenom: '' };
  }, [clientNames, client, nomClient, selectedEnregistrement.idClient]);

  const prepareEnregistrementForSave = useCallback((row: IGestionEnregistrement) => {
    const { nom, prenom } = getClientNames();
    const avecDates = {
      ...row,
      enregistrementDetails: syncDatesParticipationForEnregistrement(row, nom, prenom),
    };
    return appliquerCapturesAEnregistrement(avecDates, enregistrementDetailsCapture, capturesModifiees);
  }, [capturesModifiees, getClientNames, enregistrementDetailsCapture]);

  const handleSauvegarderClick = useCallback(async (e: { preventDefault?: boolean }) => {
    if (!sauvegarder) return;

    const messageErreurEmplacements = validerEmplacementsOntAuMoinsUnDetail(enregistrementDetailsCapture);
    if (messageErreurEmplacements) {
      alertEnregistrement('Erreur', messageErreurEmplacements);
      return;
    }

    const prepared = prepareEnregistrementForSave(selectedEnregistrement);
    Object.assign(selectedEnregistrement, prepared);

    setIsFieldModifier(false);
    e.preventDefault = true;

    const result = await sauvegarder(e);
    if (!result) {
      setIsFieldModifier(true);
      return;
    }

    setCapturesModifiees(false);
    if (selectedEnregistrement.idEnregistrementEntete) {
      setSelectedDataRow((prev) => ({
        ...prev,
        enregistrementDetails: (prev.enregistrementDetails ?? []).map((detail) => {
          const { captures: _captures, ...detailSansCaptures } = detail;
          return detailSansCaptures;
        }),
      }));

      const captureResult = await getCapture({
        customPath: `Enregistrement/${selectedEnregistrement.idEnregistrementEntete}/Captures`,
      });
      setDataSourceCapture(captureResult as IDataCapture);
    }
  }, [enregistrementDetailsCapture, getCapture, prepareEnregistrementForSave, selectedEnregistrement, setIsFieldModifier, setSelectedDataRow, sauvegarder]);

  const getVisibleDatesParticipation = useCallback((
    datesParticipation: IEnregistrementDetails['datesParticipation'] | undefined,
    dateArrive: Date,
    dateDepart: Date,
  ) => (datesParticipation ?? []).filter((entry) =>
    !entry.isDeleted
    && isParticipationDateInRange(entry.dateParticipation, dateArrive, dateDepart)
  ), []);

  const updateDetailExclusion = useCallback((
    idEnregistrementDetail: Guid,
    updater: (detail: IEnregistrementDetails) => IEnregistrementDetails,
  ) => {
    setSelectedDataRow((prev) => ({
      ...prev,
      enregistrementDetails: (prev.enregistrementDetails || []).map((detail) =>
        detail.idEnregistrementDetail?.equals(idEnregistrementDetail)
          ? updater(detail)
          : detail
      ),
    }));
    setIsFieldModifier(true);
  }, [setSelectedDataRow, setIsFieldModifier]);

  const handleDateClick = useCallback((idEnregistrementDetail: Guid, date: Date, identity: IParticipantIdentity) => {
    updateDetailExclusion(idEnregistrementDetail, (detail) =>
      toggleParticipantExclusion(detail, date, identity)
    );
  }, [updateDetailExclusion]);

  const handleSelectAllClick = useCallback((
    idEnregistrementDetail: Guid,
    identity: IParticipantIdentity,
  ) => {
    updateDetailExclusion(idEnregistrementDetail, (detail) =>
      setAllParticipantExclusions(detail, identity, true)
    );
  }, [updateDetailExclusion]);

  const handleDeselectAllClick = useCallback((
    idEnregistrementDetail: Guid,
    identity: IParticipantIdentity,
  ) => {
    updateDetailExclusion(idEnregistrementDetail, (detail) =>
      setAllParticipantExclusions(detail, identity, false)
    );
  }, [updateDetailExclusion]);

  const CustomActivitéCellTemplate = useCallback((data: DataGridTypes.ColumnCellTemplateData) => {
    const rowData = getActiviteRowData(data) as IEnregistrementDetails;
    const secteurLookup = useMemo(() => createLookup(secteurEditorOptions?.dataSource, rowData.idActivite?.toString()), [secteurEditorOptions]);
    const activiteLookup = useMemo(() => createLookup(activiteEditorOption?.dataSource, rowData.idSecteur?.toString()), [activiteEditorOption]);
    const pointEauLookup = useMemo(() => createLookup(pointEauEditorOption?.dataSource, rowData.idPointEau?.toString()), [pointEauEditorOption]);
    return (
      <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        <div><span><b>Activité: </b> </span> <span>{activiteLookup[rowData.idActivite?.toString()]}</span></div>
        <div><span><b>Secteur: </b> </span> <span>{secteurLookup[rowData.idSecteur?.toString()]}</span></div>
        <div><span><b>Point Eau: </b> </span> <span>{pointEauLookup[rowData.idPointEau?.toString()]}</span></div>
        <div><span><b>Gibier: </b> </span> <span> </span></div>
      </div>
    );
  }, [selectedEnregistrement]);

  const obtenirDetailActiviteDepuisEtat = useCallback((rowData: IEnregistrementDetails) => (
    selectedEnregistrement.enregistrementDetails?.find((detail) =>
      detail.idEnregistrementDetail?.toString() === rowData.idEnregistrementDetail?.toString()
    ) ?? rowData
  ), [selectedEnregistrement.enregistrementDetails]);

  const activiteDetailsDataSource = useMemo(
    () => [...(selectedEnregistrement?.enregistrementDetails ?? [])],
    [selectedEnregistrement?.enregistrementDetails],
  );

  const obtenirDatesActiviteFiltrees = useCallback((
    detail: IEnregistrementDetails | undefined,
    dateArrive: Date,
    dateDepart: Date,
  ) => {
    const { nom, prenom } = getClientNames();
    return filtrerParticipantsDatesParticipation(
      getVisibleDatesParticipation(detail?.datesParticipation, dateArrive, dateDepart),
      selectedEnregistrement.idClient,
      nom,
      prenom,
      selectedEnregistrement.accompagnateurs,
    );
  }, [getClientNames, getVisibleDatesParticipation, selectedEnregistrement.accompagnateurs, selectedEnregistrement.idClient]);

  const CustomClientCellTemplate = useCallback((data: DataGridTypes.ColumnCellTemplateData) => {
    const rowData = getActiviteRowData(data) as IEnregistrementDetails;
    const detail = obtenirDetailActiviteDepuisEtat(rowData);
    const visibleDates = obtenirDatesActiviteFiltrees(
      detail,
      selectedEnregistrement.dateArrive,
      selectedEnregistrement.dateDepart,
    );
    const participants = reorganizeData(visibleDates, false);

    return (
      <div className='enregistrement participant-lines'>
        {participants.map((element: { participant: string }, index: number) => (
          <div key={index}>
            <div className='participant-line-name'>{element.participant}</div>
            {index < participants.length - 1 && <hr className='separator' />}
          </div>
        ))}
      </div>
    );
  }, [selectedEnregistrement.dateArrive, selectedEnregistrement.dateDepart, obtenirDetailActiviteDepuisEtat, obtenirDatesActiviteFiltrees])


  const CustomDateCellTemplate = useCallback((data: DataGridTypes.ColumnCellTemplateData) => {
    const rowData = getActiviteRowData(data) as IEnregistrementDetails;
    const detail = obtenirDetailActiviteDepuisEtat(rowData);
    const isModifyMode = mode === Mode.Modifier;
    const hideExcludedDates = shouldHideExcludedParticipationDates(mode);
    const visibleDates = obtenirDatesActiviteFiltrees(
      detail,
      selectedEnregistrement.dateArrive,
      selectedEnregistrement.dateDepart,
    );
    const datesParticipants = reorganizeData(visibleDates, hideExcludedDates);
    return (
      <div
        className='enregistrement participant-container'
        style={{
          pointerEvents: isModifyMode ? 'auto' : 'none',
          opacity: isModifyMode ? 0.8 : 1
        }}>
        {datesParticipants.map((participant, index) => (
          <React.Fragment key={index}>
            <div className='participant-line'>
              {isModifyMode && (
                <div className='participant-buttons'>
                  <button className='select-all-dates'
                    type="button"
                    onClick={() => handleSelectAllClick(rowData.idEnregistrementDetail, participant)}
                  >
                    ✗
                  </button>
                  <button className='deselect-all-dates'
                    type="button"
                    onClick={() => handleDeselectAllClick(rowData.idEnregistrementDetail, participant)}
                  >
                    ✓
                  </button>
                </div>
              )}
              <div className='participant-dates-scroll'>
                {participant.dates.map((dateString, dateIndex) => {
                  const date = new Date(dateString);
                  const identity: IParticipantIdentity = {
                    nom: participant.nom,
                    prenom: participant.prenom,
                    idAccompagnateur: participant.idAccompagnateur,
                  };
                  const isExcluded = isDateExcludedInParticipation(
                    detail?.datesParticipation,
                    date,
                    identity,
                  );
                  if (hideExcludedDates && isExcluded) {
                    return null;
                  }
                  return (
                    <div
                      key={dateIndex}
                      className='date-container'
                      style={{ backgroundColor: isExcluded ? 'red' : 'white' }}
                      onClick={() => handleDateClick(rowData.idEnregistrementDetail, date, identity)}
                    >
                      <div>{date.getDate().toString().padStart(2, '0')}</div>
                      <div>{date.toLocaleDateString('fr-FR', { month: 'short' }).substring(0, 4)}</div>
                      {isExcluded && (
                        <div className='date-cross'>
                          &times;
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
            {index < datesParticipants.length - 1 && <hr className='separator' />}
          </React.Fragment>
        ))}
      </div>
    );
  }, [selectedEnregistrement.dateArrive, selectedEnregistrement.dateDepart, mode, handleDateClick, handleSelectAllClick, handleDeselectAllClick, obtenirDetailActiviteDepuisEtat, obtenirDatesActiviteFiltrees]);

  const CustomInfomrationsTempplate = useCallback((e: any) => {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        <div><span>Enregistrement: </span><span> {e.data.noDossier} </span></div>
        <div><span>Client: </span> <span> {e.data.nom} {e.data.prenom}</span></div>
        <div><span>Nombre de captures: </span> <span> {e.data.nbCaptures} </span></div>
      </div>
    )
  }, [selectedEnregistrement])

  const calculateCellValue = useCallback((rowData: any) => {
    const formattedDate = format(new Date(rowData.dateFacturation), 'dd MMM yyyy, HH:mm');
    return `Facture #${rowData.noFacture}  Date:${formattedDate}   Montant:${rowData.montant}  Solde:${rowData.solde}`;
  }, [])

  const factureGroupCellRender = useCallback((cell: any) => {
    const facture = dataSourceFacturationDetails.find((detail) =>
      detail.idFacturationEntete?.toString() === cell.value?.toString()
    );

    return facture ? calculateCellValue(facture) : (cell.value?.toString() ?? '');
  }, [calculateCellValue, dataSourceFacturationDetails]);

  const handleFactureRowDblClick = useCallback((e: DataGridTypes.RowDblClickEvent) => {
    const idFacturationEntete = e.rowType === 'group'
      ? (Array.isArray(e.key) ? e.key[0] : e.key)
      : e.data?.idFacturationEntete;

    if (!idFacturationEntete) {
      return;
    }

    const id = idFacturationEntete instanceof Guid
      ? idFacturationEntete
      : new Guid(String(idFacturationEntete));

    if (id.isEmpty()) {
      return;
    }

    setIdFacturationEntetePopup(id);
    setIsPopupFacturationOpen(true);
  }, []);

  const onValueActiviteChangedSelected = useCallback((component: any) => {
    setDataSourceSelectpointEau([]);
    setDataSourceSelectSecteur([]);
    if (!component.value) return;
    const valueSelected = dataSourceSelectActivite?.find((activite: IActiviteEnregistrement) => activite.id.toString() === component.value.toString());
    if (valueSelected) {
      setIdActiviteSelected(valueSelected.id);
      setSelectedActivite(valueSelected.id);
      if (valueSelected.demanderPointEau) {
        fetchAndSetData(`PointEau/lookupEnregistrementByActivite`, setDataSourceSelectpointEau);
      }
      if (valueSelected.demanderSecteur) {
        fetchAndSetData(`Secteur/lookupByActivite`, setDataSourceSelectSecteur);
      }
    }
  }, [dataSourceSelectActivite, fetchAndSetData]);

  const onValuePointEauChangedSelected = useCallback((component: any) => {
    setSelectedPointEau(component.value);
    type PointEau = {
      idPointEau: string;
      pointEau: string;
      pointEauFerme: boolean;
      quotaAtteint: boolean;
      pourcentageQuotaAtteint: number,
      espece: string,
      quotaAvertissementAtteint: boolean;
      isDeleted: boolean;
    };
    if (idActiviteSelected) {
      fetchData("get", { customPath: `PointEau/${component.value}/ValidationPointEau?idActivite=${idActiviteSelected}` })
        .then((result) => {
          const validationPointEau = result as PointEau;
          if (validationPointEau?.quotaAtteint) alertEnregistrement(`Avertissement`, `Le quota du point d'eau ${validationPointEau.idPointEau} est atteint. Voulez vous continuer ? ${component.value}`);
          if (validationPointEau?.quotaAvertissementAtteint) alertEnregistrement(`Avertissement`, `Le quota de ce cours d'eau est atteint avec un pourcentage de : ${validationPointEau.pourcentageQuotaAtteint}`);
          if (validationPointEau?.pointEauFerme) alertEnregistrement(`Avertissement`, `Le point d'eau ${validationPointEau.pointEau} est fermé`);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [idActiviteSelected, fetchData]);

  const onValueSecteurChangedSelected = useCallback((component: any) => {
    setSelectedSecteur(component.value);
  }, []);

  const handleAddActivity = useCallback(() => {
    if (!selectedActivite) {
      alertEnregistrement('Erreur', 'Veuillez sélectionner une activité');
      return;
    }

    const existingActivity = selectedEnregistrement?.enregistrementDetails?.find(
      (detail: any) =>
        detail.idActivite === selectedActivite &&
        detail.idSecteur === selectedSecteur &&
        detail.idPointEau === selectedPointEau &&
        !detail.isDeleted
    );

    if (existingActivity) {
      alertEnregistrement('Erreur', 'Cette activité est déjà présente dans l\'enregistrement');
      return;
    }

    const dateFin = selectedEnregistrement.dateDepart;
    const idEnregistrementDetail = Guid.newTemporary();
    const { nom: clientNom, prenom: clientPrenom } = getClientNames();

    const newActivity: any = {
      gibiers: [],
      datesParticipation: buildDatesParticipation({
        dateArrive: selectedEnregistrement.dateArrive,
        dateDepart: selectedEnregistrement.dateDepart,
        idEnregistrementEntete: selectedEnregistrement.idEnregistrementEntete!,
        idEnregistrementDetail,
        idClient: selectedEnregistrement.idClient,
        clientNom,
        clientPrenom,
        accompagnateurs: selectedEnregistrement.accompagnateurs,
      }),
      dateDebut: selectedEnregistrement.dateArrive,
      dateFin,
      heureDebut: null,
      heureFin: null,
      dateFinReel: addDays(new Date(dateFin), 2),
      heureFinReel: null,
      actif: true,
      idClient: selectedEnregistrement.idClient,
      dateCreation: new Date(),
      dateModification: new Date(),
      dateSuppression: null,
      idEnregistrementDetail,
      idEnregistrementEntete: selectedEnregistrement.idEnregistrementEntete,
      idActivite: selectedActivite,
      idSecteur: selectedSecteur || Guid.empty,
      idPointEau: selectedPointEau || Guid.empty,
      idNote: Guid.empty,
      idUsagerCreation: Guid.empty,
      idUsagerModification: Guid.empty,
      idUsagerSuppression: null,
      genere: false,
      isDeleted: false
    };

    console.log('newActivity', newActivity);
    setSelectedDataRow((prev) => ({
      ...prev,
      enregistrementDetails: [
        ...(prev.enregistrementDetails || []),
        newActivity
      ]
    }));

    setIsFieldModifier(true);

    // Clear
    setSelectedActivite(undefined);
    setSelectedSecteur(undefined);
    setSelectedPointEau(undefined);
    setIdActiviteSelected(Guid.empty);
    setDataSourceSelectSecteur([]);
    setDataSourceSelectpointEau([]);
  }, [selectedActivite, selectedSecteur, selectedPointEau, selectedEnregistrement, setIsFieldModifier, setSelectedDataRow, getClientNames]);

  const handleRemoveEnregistrementDetail = useCallback(async (e: DataGridTypes.RowRemovingEvent) => {
    e.cancel = true;
    setSelectedDataRow((prev) => ({
      ...prev,
      enregistrementDetails: (prev.enregistrementDetails || []).map((detail) =>
        detail.idEnregistrementDetail === e.data.idEnregistrementDetail
          ? { ...detail, isDeleted: true }
          : detail
      )
    }));
    setIsFieldModifier(true);
  }, [setIsFieldModifier, setSelectedDataRow]);

  const syncAccompagnateursFromGrid = useCallback((e: { component: { option: (name: string) => unknown } }) => {
    const accompagnateurs = e.component.option('dataSource') as IGestionEnregistrement['accompagnateurs'];
    setSelectedDataRow((prev) => {
      const updated = {
        ...prev,
        accompagnateurs: [...(accompagnateurs || [])],
      };
      const { nom, prenom } = getClientNames();
      return {
        ...updated,
        enregistrementDetails: syncDatesParticipationForEnregistrement(updated, nom, prenom),
      };
    });
    setIsFieldModifier(true);
  }, [setSelectedDataRow, setIsFieldModifier, getClientNames]);

  const handleRemoveAccompagnateur = useCallback(async (e: DataGridTypes.RowRemovingEvent) => {
    e.cancel = true;
    const removedAccompagnateur = e.data as IEnregistrementAccompagnateur;

    setSelectedDataRow((prev) => {
      const accompagnateurs = (prev.accompagnateurs || []).map((accompagnateur) =>
        accompagnateur.idEnregistrementAccompagnateurs === removedAccompagnateur.idEnregistrementAccompagnateurs
          ? { ...accompagnateur, isDeleted: true }
          : accompagnateur
      );

      const { nom, prenom } = getClientNames();
      const detailsSansAccompagnateur = removeAccompagnateurDesDetailsEnregistrement(
        prev.enregistrementDetails || [],
        removedAccompagnateur,
      );

      const updated = {
        ...prev,
        accompagnateurs,
        enregistrementDetails: detailsSansAccompagnateur,
      };

      return {
        ...updated,
        enregistrementDetails: syncDatesParticipationForEnregistrement(updated, nom, prenom),
      };
    });
    setIsFieldModifier(true);
  }, [setIsFieldModifier, setSelectedDataRow, getClientNames]);

  const onEnregistrementFieldDataChanged = useCallback((e: { dataField?: string; value?: Date }) => {
    setIsFieldModifier(true);
    if (e.dataField !== 'dateArrive' && e.dataField !== 'dateDepart') {
      return;
    }
    setSelectedDataRow((prev) => {
      const updated = {
        ...prev,
        [e.dataField!]: e.value,
      };
      const { nom, prenom } = getClientNames();
      return {
        ...updated,
        enregistrementDetails: syncDatesParticipationForEnregistrement(updated, nom, prenom),
      };
    });
  }, [setIsFieldModifier, setSelectedDataRow, getClientNames]);

  const handleFormFieldDataChanged = useCallback((e: { dataField?: string; value?: Date }) => {
    onFieldDataChanged(e as any);
    onEnregistrementFieldDataChanged(e);
  }, [onFieldDataChanged, onEnregistrementFieldDataChanged]);

  const onAccompagnateurInitNewRow = useCallback((e: DataGridTypes.InitNewRowEvent<IEnregistrementAccompagnateur>) => {
    if (!selectedEnregistrement.idEnregistrementEntete) return;

    e.data.idEnregistrementAccompagnateurs = Guid.newTemporary();
    e.data.idEnregistrementDetail = Guid.empty;
    e.data.idEnregistrementEntete = selectedEnregistrement.idEnregistrementEntete;
    e.data.idClient = selectedEnregistrement.idClient;
    e.data.idAccompagnateur = Guid.empty;
    e.data.actif = true;
    e.data.dissocier = false;
    e.data.isDeleted = false;
    e.data.prenom = e.data.prenom ?? '';
    e.data.nom = e.data.nom ?? '';
    e.data.plaque = e.data.plaque ?? '';
    e.data.noFqcq = e.data.noFqcq ?? '';
  }, [selectedEnregistrement]);

  const normaliserNomAccompagnateur = useCallback((valeur?: string) => (valeur ?? '').trim().toLowerCase(), []);

  const accompagnateurCorrespondHistorique = useCallback((
    accompagnateur: IEnregistrementAccompagnateur,
    historique: IHistoriqueAccompagnateur,
  ) => normaliserNomAccompagnateur(accompagnateur.nom) === normaliserNomAccompagnateur(historique.nom)
    && normaliserNomAccompagnateur(accompagnateur.prenom) === normaliserNomAccompagnateur(historique.prenom),
  [normaliserNomAccompagnateur]);

  const clientDisplayName = useMemo(() => {
    const { nom, prenom } = getClientNames();
    return [nom, prenom].filter(Boolean).join(' ') || nomClient;
  }, [getClientNames, nomClient]);

  const handleHistoriqueAccompagnateursConfirm = useCallback((lignes: IHistoriqueAccompagnateur[]) => {
    if (!selectedEnregistrement.idEnregistrementEntete) return;

    setSelectedDataRow((prev) => {
      const accompagnateurs = [...(prev.accompagnateurs || [])];

      const trouverIndex = (ligne: IHistoriqueAccompagnateur) => accompagnateurs.findIndex((accompagnateur) =>
        accompagnateurCorrespondHistorique(accompagnateur, ligne),
      );

      lignes.forEach((ligne) => {
        const index = trouverIndex(ligne);

        if (ligne.inclus) {
          if (index >= 0) {
            accompagnateurs[index] = {
              ...accompagnateurs[index],
              isDeleted: false,
              idClient: ligne.idClient,
              nom: ligne.nom,
              prenom: ligne.prenom,
            };
          } else {
            accompagnateurs.unshift({
              ...new IBaseModel(),
              idEnregistrementAccompagnateurs: Guid.newTemporary(),
              idEnregistrementDetail: Guid.empty,
              idEnregistrementEntete: selectedEnregistrement.idEnregistrementEntete!,
              idClient: ligne.idClient,
              idAccompagnateur: Guid.empty,
              actif: true,
              dissocier: false,
              isDeleted: false,
              nom: ligne.nom,
              prenom: ligne.prenom,
              plaque: '',
              noFqcq: '',
            });
          }
          return;
        }

        if (index >= 0 && !accompagnateurs[index].isDeleted) {
          accompagnateurs[index] = { ...accompagnateurs[index], isDeleted: true };
        }
      });

      const updated = { ...prev, accompagnateurs };
      const { nom, prenom } = getClientNames();
      return {
        ...updated,
        enregistrementDetails: syncDatesParticipationForEnregistrement(updated, nom, prenom),
      };
    });
    setIsFieldModifier(true);
  }, [
    accompagnateurCorrespondHistorique,
    getClientNames,
    selectedEnregistrement.idEnregistrementEntete,
    setIsFieldModifier,
    setSelectedDataRow,
  ]);

  const Legend = () => (
    <div style={{ marginTop: "5px", display: "flex", gap: "10px", alignItems: "center" }}>
      <div
        style={{
          width: "100px",
          height: "40px",
          backgroundColor: "#C2FD4B",
          // border: "solid 2px #717173",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontWeight: "bold",
          textAlign: "center"
        }}
      >
        Feuillet remis
      </div>
      <div
        style={{
          width: "100px",
          height: "40px",
          backgroundColor: "#FFFF01",
          // border: "solid 2px #717173",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontWeight: "bold",
          textAlign: "center"
        }}
      >
        Feuillet non-remis
      </div>
      <div
        style={{
          width: "100px",
          height: "40px",
          backgroundColor: "#FF9C7F",
          // border: "solid 2px #717173",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontWeight: "bold",
          textAlign: "center"
        }}
      >
        Expiré
      </div>
      <div
        style={{
          width: "100px",
          height: "40px",
          backgroundColor: "#A9A9A9",
          // border: "solid 2px #717173",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontWeight: "bold",
          textAlign: "center"
        }}
      >
        Annulé
      </div>
    </div>
  );

  return (
    <FormListBase data={enregistrementFormDataSource}>
      <FormListBaseGrid dataSource={enregistrementFormDataSource.dataSource}
        onFocusedRowChanged={(e: any) => {
          if (mode === Mode.Modifier && !isModeSelection) setMode(Mode.Lecture);
          if (setSelectedValue && e.row?.data) {
            setSelectedValue(e.row.data);
          }
        }}
        onCellPrepared={(e: any) => {
          if (e?.rowType === "data"
            && e?.values?.[0] !== selectedEnregistrement?.noEnregistrement) {
            if (!e?.data?.dateDepart) {
              // e.cellElement.style.backgroundColor = "#FF9C7F";
              return
            }
            const dateDepart = new Date(e.data.dateDepart);
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const isExpired = dateDepart < today;
            if (isExpired) {
              // if (e.column.dataField === "dateDepart" && e.rowType === "data") {
              e.cellElement.style.backgroundColor = "#FF9C7F";
            }
          }
        }}
        legend={<Legend />}
      >
        <Column key={"grid-col-noEnregistrement"} dataField={"noEnregistrement"} caption="Numéro" allowHiding={false} />
        <Column key={"grid-col-client"} dataField={"idClient"} caption="Client" allowHiding={false}>
          <Lookup {...clientEditorOptions} />
        </Column>
        <Column key={"grid-col-dateArrive"}
          dataField={"dateArrive"}
          caption="Date d'arrivee" allowHiding={false} format="yyyy-MM-dd"
        />
        <Column key={"grid-col-dateDepart"}
          dataField={"dateDepart"}
          caption="Date de départ" allowHiding={false} format="yyyy-MM-dd"
        />
        <Column key={"grid-col-telephone"} dataField={"telephone"} caption="Téléphone" allowHiding={false} />
        <Column key={"grid-col-reference"} dataField={"reference"} caption="Référence" allowHiding={false} />
      </FormListBaseGrid>
      <FormListBaseToolbar headerText={`Enregistrement #${selectedEnregistrement?.noEnregistrement || ''}`} sauvegarderOptions={{ disabled: !isFieldModifier, click: handleSauvegarderClick }} annulerOptions={{ disabled: !isFieldModifier }} />
      <FormListBaseTab>
        <TabItem title="Enregistrement">
          <Form ref={formRef} readOnly={mode === Mode.Lecture} formData={selectedEnregistrement || {} as IGestionEnregistrement} className={"forms"} labelLocation={"left"} showColonAfterLabel={true} onFieldDataChanged={handleFormFieldDataChanged}>
            <PopupGestionClient isModeSelection={mode !== Mode.Lecture} onSelectionchanged={(i) => onSelectionchanged(i, 'idClient')} />
            <GroupItem colCount={3}>
              <GroupItem colSpan={1}>
                <GroupItem caption={'Personne responsable'}>
                  <SimpleItem key={"frm-id-client"} dataField={"idClient"} editorOptions={clientEditorOptions} editorType={'dxSelectBox'}>
                    <Label text={"Client"} />
                  </SimpleItem>
                  <SimpleItem key={"frm-date-Plaque-1"} dataField={"plaque1"} editorType={"dxSelectBox"}
                    editorOptions={plaquesEditorOption}
                  >
                    <Label text={"Plaque 1"} />
                  </SimpleItem>
                  <SimpleItem key={"frm-date-Plaque-2"} dataField={"plaque2"} editorType={"dxSelectBox"}
                    editorOptions={plaquesEditorOption}
                  >
                    <Label text={"Plaque 2"} />
                  </SimpleItem>
                  <SimpleItem key={"frm-date-Plaque-3"} dataField={"plaque3"} editorType={"dxSelectBox"}
                    editorOptions={plaquesEditorOption}
                  >
                    <Label text={"Plaque 3"} />
                  </SimpleItem>
                  <SimpleItem key={"frm-id-fqcq"} dataField={"noFqcq"}>
                    <Label text={"Numéro FQCQ"} />
                  </SimpleItem>
                </GroupItem>
                <GroupItem caption={'Séjour'}>
                  <SimpleItem key={"frm-date-date-arrivee"} dataField={"dateArrive"} editorType={"dxDateBox"} editorOptions={dateEditorOptions}>
                    <Label text={"Date arrivée"} />
                  </SimpleItem>
                  <SimpleItem key={"frm-date-date-depart"} dataField={"dateDepart"} editorType={"dxDateBox"} editorOptions={dateEditorOptions}>
                    <Label text={"Date de départ"} />
                  </SimpleItem>
                  <SimpleItem key={"frm-date-Type-de-sejour"} dataField={"idTypeSejour"} editorType={"dxSelectBox"}
                    editorOptions={typeSejourEditorOption}
                  >
                    <Label text={"Type de Séjour"} />
                  </SimpleItem>
                  <SimpleItem key={"frm-id-lieu-de-sejour"} dataField={"idLieuSejour"} editorType={"dxSelectBox"}
                    editorOptions={lieuSejourEditorOption}
                  >
                    <Label text={"Lieu de Séjour"} />
                  </SimpleItem>
                </GroupItem>

                <GroupItem>
                  <GroupItem colSpan={1} caption={'Accompagnateurs'}>
                    <DataGrid
                      showBorders={true}
                      allowColumnResizing={true}
                      keyExpr="idEnregistrementAccompagnateurs"
                      filterValue={accompagnateursFilterValue}
                      dataSource={selectedEnregistrement?.accompagnateurs}
                      noDataText={""}
                      onInitNewRow={onAccompagnateurInitNewRow}
                      onRowUpdated={syncAccompagnateursFromGrid}
                      onRowInserted={syncAccompagnateursFromGrid}
                      onRowRemoving={handleRemoveAccompagnateur}
                    >
                      <Editing
                        mode="cell"
                        allowUpdating={mode !== Mode.Lecture}
                        allowDeleting={mode !== Mode.Lecture}
                        allowAdding={mode !== Mode.Lecture}
                        newRowPosition={"first"}
                      />
                      <Column caption={"Nom"} dataField='nom' />
                      <Column caption={"Prénom"} dataField='prenom' />
                      <Column caption={"#Plaque"} dataField='plaque' />
                      <Column caption={"Numéro FQCQ"} dataField='noFqcq' />
                      <Column dataField="idEnregistrementDetail" visible={false} />
                      <Column dataField="idAccompagnateur" visible={false} />
                      <Column dataField="idEnregistrementEntete" visible={false} />
                      <Column dataField="idClient" visible={false} />
                      <Column dataField="isDeleted" dataType="boolean" visible={false} />
                    </DataGrid>
                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
                      <Button
                        text={'Historique des accompagnateurs'}
                        disabled={mode === Mode.Lecture || !selectedEnregistrement.idClient || selectedEnregistrement.idClient.equals(Guid.empty)}
                        onClick={() => setIsHistoriqueAccompagnateursOpen(true)}
                      />
                    </div>
                  </GroupItem>

                </GroupItem>
              </GroupItem>
              <GroupItem caption={'Enregistrement'} colSpan={2}>
                <GroupItem alignItemLabels={false} colCount={2}>
                  <SimpleItem key={"frm-actif-feuillet-enregistrement-remis"} dataField={"ficheRemis"} editorType={"dxCheckBox"} >
                    <Label showColon={false} text={"Le feuillet d'enregistrement à été rémis"} />
                  </SimpleItem>
                  <SimpleItem key={"frm-date-reelle-sortie"}
                    dataField={"dateDepartReel"} editorType={"dxDateBox"}>
                    <Label text={"Date réelle de sortie"} />
                  </SimpleItem>
                </GroupItem>
                <GroupItem alignItemLabels={false} colCount={2}>
                  <SimpleItem key={"frm-actif-enregistrement-annule"} dataField={"annule"} editorType={"dxCheckBox"} >
                    <Label text={"Enregistrement annulé"} />
                  </SimpleItem>
                  <SimpleItem key={"frm-actif-reference"} dataField={"reference"} editorType={"dxTextBox"} >
                    <Label text={"Réference"} />
                  </SimpleItem>
                </GroupItem>
                <GroupItem colCount={3}>
                  <GroupItem colCount={3} colSpan={2}>
                    <GroupItem>
                      <div>Activité</div>
                      <SelectBox
                        disabled={mode === Mode.Lecture}
                        valueExpr={'id'}
                        value={selectedActivite}
                        onValueChanged={onValueActiviteChangedSelected}
                        displayExpr={'description'}
                        dataSource={dataSourceSelectActivite}
                      />
                    </GroupItem>
                    {
                      dataSourceSelectSecteur && dataSourceSelectSecteur?.length > 0 &&
                      <GroupItem>
                        <div> Secteur</div>
                        <SelectBox
                          dataSource={dataSourceSelectSecteur}
                          onValueChanged={onValueSecteurChangedSelected}
                          value={selectedSecteur}
                          valueExpr={'id'}
                          displayExpr={'description'} />
                      </GroupItem>
                    }
                    {
                      dataSourceSelectpointEau && dataSourceSelectpointEau?.length > 0 &&
                      <GroupItem>
                        <div> point Eau</div>
                        <SelectBox
                          dataSource={dataSourceSelectpointEau}
                          onValueChanged={onValuePointEauChangedSelected}
                          value={selectedPointEau}
                          valueExpr={'id'}
                          displayExpr={'description'}
                        />
                      </GroupItem>
                    }
                  </GroupItem>
                  <GroupItem>
                    <Button text={'Ajouter'}
                      disabled={mode === Mode.Lecture}
                      onClick={handleAddActivity}
                    />
                  </GroupItem>
                </GroupItem>
                <GroupItem>
                  <DataGrid
                    showColumnLines={true}
                    showBorders={true}
                    allowColumnResizing={true}
                    keyExpr="idEnregistrementDetail"
                    filterValue={enregistrementDetailsFilterValue}
                    dataSource={activiteDetailsDataSource}
                    onRowRemoving={handleRemoveEnregistrementDetail}>
                    <Column
                      caption={"Activité"}
                      dataField='idActivite'
                      cellComponent={CustomActivitéCellTemplate} />
                    <Column
                      caption={"Client"}
                      dataField='idClient'
                      cellComponent={CustomClientCellTemplate} />
                    <Column
                      caption={"Dates de participation"}
                      dataField='datesParticipation'
                      cellRender={CustomDateCellTemplate} />
                    <Column dataField="isDeleted" dataType="boolean" visible={false} />
                    <Editing
                      mode={"row"}
                      newRowPosition={"first"}
                      allowDeleting={mode !== Mode.Lecture}
                    />
                  </DataGrid>
                </GroupItem>
                <GroupItem colSpan={2} caption={'Notes'}>
                  <SimpleItem key={"frm-remarques"} dataField='notes' editorType={"dxTextArea"} editorOptions={notesOptions}>
                    <Label text={"Remarques"} location={"top"} visible={false} />
                  </SimpleItem>
                </GroupItem>
              </GroupItem>
            </GroupItem>
          </Form>
        </TabItem>
        <TabItem title="Forfaits Facturés">
          <Form readOnly={true} alignItemLabelsInAllGroups={true} formData={selectedEnregistrement || {} as IGestionEnregistrement} className={"forms"} labelLocation={"left"} showColonAfterLabel={true}>
            <GroupItem colCount={2}>
              <GroupItem>
                <DataGrid showBorders={true} allowColumnResizing={true} dataSource={dataSourceForfaitsFactures?.forfaitHistorique || []}>
                  <Column caption={nomClient} dataField='description' dataType='string' />
                </DataGrid>
              </GroupItem>
              <GroupItem>
                <DataGrid showBorders={true} allowColumnResizing={true} dataSource={dataSourceForfaitsFactures?.personneAssocieeHistorique || []}>
                  <Column caption={"Personnes associées"} dataField='idClient' dataType='string'>
                    <Lookup {...clientEditorOptions} />
                  </Column>
                  <Column caption={"Age"} dataField='age' dataType='number' />
                </DataGrid>
              </GroupItem>
            </GroupItem>
          </Form>
        </TabItem>
        <TabItem title="Factures de l'enregistrement">
          <Form readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedEnregistrement || {} as IGestionEnregistrement} className={"forms"} labelLocation={"left"} showColonAfterLabel={true}>
            <GroupItem>
              <DataGrid
                showBorders={true}
                allowColumnResizing={true}
                dataSource={dataSourceFacturationDetails}
                onRowDblClick={handleFactureRowDblClick}
              >
                <GroupPanel visible={true} />
                <Grouping autoExpandAll={false} />
                <Column
                  caption={"Facture"}
                  dataField='idFacturationEntete'
                  groupIndex={0}
                  groupCellRender={factureGroupCellRender} />
                <Column caption={"Description"} dataField='description' />
                <Column caption={"Date de vente"} dataField='dateFacturation' />
                <Column caption={"Nb. Jours"} dataField='nombreDeJours' />
                <Column caption={"Nb. Pers"} dataField='nombrePersonnes' />
                <Column caption={"Quantité"} dataField='qteVendues' />
                <Column caption={"Prix"} dataField='prixUnitaire' />
                <Column caption={"Montant"} dataField='montant' />
              </DataGrid>
            </GroupItem>
          </Form>
        </TabItem>
        <TabItem title="Captures">
          <Form readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedEnregistrement || {} as IGestionEnregistrement} className={"forms"} labelLocation={"left"} showColonAfterLabel={true}>
            <GroupItem>
              <DataGrid showBorders={true} allowColumnResizing={true} dataSource={dataSourceCapture?.infosCapture}>
                <Column caption={"Informations"} cellRender={CustomInfomrationsTempplate} >
                </Column>
              </DataGrid>
            </GroupItem>
            <GroupItem>
              <div className="toolbar-header" >Activité</div>
              <DataGrid
                showBorders={true}
                allowColumnResizing={true}
                dataSource={enregistrementDetailsCapture}
                keyExpr="idEnregistrementDetail"
                focusedRowEnabled={true}
                focusedRowKey={idEnregistrementDetailCaptureSelectionne}
                onFocusedRowChanged={handleActiviteCaptureFocusedRowChanged}
              >
                <Column caption={"Activité"} dataField='idActivite'>
                  <Lookup {...activiteEditorOption} />
                </Column>
                <Column caption={"Secteur"} dataField='idSecteur'>
                  <Lookup {...secteurEditorOption} />
                </Column>
                <Column caption={"Point Eau"} dataField='idPointEau'>
                  <Lookup {...pointEauEditorOption} />
                </Column>
              </DataGrid>
            </GroupItem>
            <div className="toolbar-header" >Détails des captures</div>
            <GroupItem colCount={2}>
              <GroupItem>
                <div className="toolbar-header" >Emplacements</div>
                <div className="captures-toolbar">
                  <Button
                    text="Ajouter emplacement"
                    icon="add"
                    disabled={
                      mode === Mode.Lecture
                      || !detailCaptureSelectionne
                      || (!detailCaptureSelectionne.peche && !detailCaptureSelectionne.chasse)
                    }
                    onClick={handleAjouterEmplacement}
                  />
                  <Button
                    text="Supprimer"
                    icon="remove"
                    disabled={mode === Mode.Lecture || !idCaptureSelectionne}
                    onClick={handleSupprimerEmplacement}
                  />
                </div>
                <CapturesEmplacementsGrid
                  emplacements={emplacementsSelectionnes}
                  chasse={detailCaptureSelectionne?.chasse ?? chasse}
                  isModeModifier={mode !== Mode.Lecture}
                  selectedCaptureId={idCaptureSelectionne}
                  onSelectionChanged={setIdCaptureSelectionne}
                  onEmplacementUpdated={handleEmplacementUpdated}
                />
              </GroupItem>
              <GroupItem>
                <div className="toolbar-header" >Détails</div>
                <div className="captures-toolbar">
                  <Button
                    text="Ajouter détail"
                    icon="add"
                    disabled={mode === Mode.Lecture || !idCaptureSelectionne}
                    onClick={handleAjouterDetailCapture}
                  />
                  <Button
                    text="Supprimer"
                    icon="remove"
                    disabled={mode === Mode.Lecture || !idCaptureDetailSelectionne}
                    onClick={handleSupprimerDetailCapture}
                  />
                </div>
                <CapturesDetailsGrid
                  capturesDetails={detailsCaptureSelectionnes}
                  isModeModifier={mode !== Mode.Lecture}
                  selectedCaptureDetailId={idCaptureDetailSelectionne}
                  onSelectionChanged={setIdCaptureDetailSelectionne}
                  onDetailUpdated={handleDetailCaptureUpdated}
                />
              </GroupItem>
            </GroupItem>
          </Form>
        </TabItem>
        <TabItem title="Système">
          <FormSysteme formData={selectedEnregistrement || {} as IGestionEnregistrement} />
        </TabItem>
      </FormListBaseTab>
      <PopupHistoriqueAccompagnateurs
        visible={isHistoriqueAccompagnateursOpen}
        idClient={selectedEnregistrement.idClient}
        clientDisplayName={clientDisplayName}
        accompagnateursActuels={selectedEnregistrement.accompagnateurs ?? []}
        onClose={() => setIsHistoriqueAccompagnateursOpen(false)}
        onConfirm={handleHistoriqueAccompagnateursConfirm}
      />
      {isPopupFacturationOpen ? (
        <PopupPage
          titre="Gestion facturation"
          isPopupOpen={isPopupFacturationOpen}
          onClose={() => {
            setIsPopupFacturationOpen(false);
            setIdFacturationEntetePopup(undefined);
          }}
          mode={"ajout"}
          height={"80%"}
          width={"80%"}
        >
          <GestionFacturation idFacturationEntete={idFacturationEntetePopup} />
        </PopupPage>
      ) : null}
    </FormListBase >
  );
}
